import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["children", "singleLine", "indentLevel", "width", "className"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import CommonCell from './internal/common-cell';
import OverflowContainer from './internal/overflow-container';
import { indentBase } from './internal/styled';
import withColumnWidth from './internal/with-column-width';
var CellComponent = /*#__PURE__*/function (_Component) {
  _inherits(CellComponent, _Component);
  var _super = _createSuper(CellComponent);
  function CellComponent() {
    _classCallCheck(this, CellComponent);
    return _super.apply(this, arguments);
  }
  _createClass(CellComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        singleLine = _this$props.singleLine,
        indentLevel = _this$props.indentLevel,
        width = _this$props.width,
        className = _this$props.className,
        props = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(CommonCell, _extends({
        indent: indentLevel ? "calc(".concat(indentBase, " * ").concat(indentLevel, ")") : undefined,
        width: width
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        ,
        className: className
      }, props), /*#__PURE__*/React.createElement(OverflowContainer, {
        isSingleLine: singleLine
      }, children));
    }
  }]);
  return CellComponent;
}(Component);
var Cell = withColumnWidth(CellComponent);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Cell;